<div class="card p-3 h-100">
	<div class="dashboard-metric">
		<div class="title">
			{{ input.primaryTitle }}
		</div>
		<div class="value d-flex align-items-center">
			<span class="m-0">{{ input.primaryValue }}</span>
			<span class="delta-chip" *ngIf="input.changeValue" [ngClass]="input.changePositive ? 'up' : 'down'">
				<span *ngIf="input.changePositive && input.changeValue != '0'">+</span>{{ input.changeValue }}
			</span>
		</div>
		<div class="subtext text-muted small mt-1" *ngIf="input.secondaryTitle && input.secondaryValue">
			{{ input.secondaryTitle }} {{ input.secondaryValue }}
		</div>
	</div>
</div>
